import { variantProvider } from '@/app'

export const getTitleStyles = (charDescriptionCount: number) => {
  if (charDescriptionCount <= 90) return [styles.titleLarge]
  return [styles.titleMedium]
}

export const getDescriptionStyles = (charDescriptionCount: number) => {
  if (charDescriptionCount <= 90) return [styles.descriptionLarge]
  if (charDescriptionCount <= 270) return [styles.descriptionMedium]
  return [styles.descriptionSmall]
}

export const getDescriptionRandomColor = (id?: number) => {
  const colors = ['primary4', 'lavender4', 'purple4']
  const index = Number(id ?? 0)
  const colorIndex = index % 3
  const randomColor = colors[colorIndex]

  return `color:${randomColor}`
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    titleLarge: {
      fontSize: 32,
      fontWeight: 700,
      letterSpacing: -0.5,
      lineHeight: '100%',
      color: theme.colors.neutral8,
      [theme.media.down('small')]: {
        fontSize: 28
      }
    },
    titleMedium: {
      fontSize: 28,
      fontWeight: 700,
      letterSpacing: -0.5,
      lineHeight: '100%',
      color: theme.colors.neutral8,
      [theme.media.down('small')]: {
        fontSize: 24
      }
    },
    descriptionLarge: {
      fontSize: 28,
      lineHeight: '100%',
      opacity: 0.8,
      letterSpacing: -0.2,
      [theme.media.down('small')]: {
        fontSize: 32
      }
    },
    descriptionMedium: {
      fontSize: 22,
      lineHeight: '100%',
      opacity: 0.8,
      letterSpacing: -0.2,
      [theme.media.down('small')]: {
        fontSize: 24
      }
    },
    descriptionSmall: {
      fontSize: 18,
      lineHeight: '100%',
      opacity: 0.8,
      letterSpacing: -0.2,
      [theme.media.down('small')]: {
        fontSize: 22
      }
    }
  }),
  true
)
